import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaSearch } from 'react-icons/fa';
import axios from 'axios';

const API_URL = 'https://aamirsaba.com/api';

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterCategory, setFilterCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  const categories = ['All', 'Training', 'Automation', 'Development', 'Infrastructure'];

  useEffect(() => {
    axios.get(`${API_URL}/services`)
      .then(response => {
        console.log('Services loaded:', response.data);
        setServices(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading services:', error);
        setLoading(false);
      });
  }, []);

  const filteredServices = services.filter(service => {
    const matchesCategory = filterCategory === 'All' || service.category === filterCategory;
    const matchesSearch = service.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          service.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  if (loading) {
    return (
      <section className="pt-32 pb-20 bg-darkNavy min-h-screen">
        <div className="container mx-auto px-6 text-center">
          <div className="text-cyan text-xl">Loading services...</div>
        </div>
      </section>
    );
  }

  return (
    <section className="pt-32 pb-20 bg-darkNavy min-h-screen">
      <div className="container mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-12">
          <h1 className="text-4xl md:text-6xl font-bold">Our <span className="text-cyan">Services</span></h1>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto">Comprehensive digital solutions to transform your business</p>
        </motion.div>

        <div className="flex flex-col md:flex-row gap-4 mb-8">
          <div className="flex-1 relative">
            <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500" />
            <input
              type="text"
              placeholder="Search services..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-12 pr-4 py-3 bg-navy border border-gray-700 rounded-lg text-white focus:border-cyan focus:outline-none"
            />
          </div>
          <div className="flex gap-2 flex-wrap">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setFilterCategory(cat)}
                className={"px-4 py-2 rounded-full text-sm font-medium transition " +
                  (filterCategory === cat
                    ? 'bg-cyan text-navy'
                    : 'bg-navy text-gray-400 border border-gray-700 hover:border-cyan hover:text-white')}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <p className="text-gray-400 text-sm mb-6">Showing {filteredServices.length} of {services.length} services</p>

        {filteredServices.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-400 text-lg">No services found matching your criteria.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredServices.map((service, index) => {
              let features = service.features;
              if (typeof features === 'string') {
                try { features = JSON.parse(features); } catch(e) { features = []; }
              }
              if (!Array.isArray(features)) features = [];

              return (
                <motion.div
                  key={service.id || index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.05 }}
                  className="bg-navy rounded-xl p-6 border border-gray-800 hover:border-cyan transition group"
                >
                  <span className="text-xs text-cyan uppercase tracking-wider">{service.category}</span>
                  <h3 className="text-xl font-semibold mt-2 text-white">{service.title}</h3>
                  <p className="text-gray-400 text-sm mt-2">{service.description}</p>
                  <Link 
                    to={`/services/${service.slug}`} 
                    className="inline-block mt-4 text-cyan hover:text-cyan/80 font-medium hover:underline transition"
                  >
                    Learn More →
                  </Link>
                </motion.div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default Services;
